<div (clickOutside)="clickOutside()" class="language-dropdown">
  <button [attr.aria-label]="getFrTitle()"
    (click)="toggleDropdown()"
          [ngClass]="{'is-open':isDropdownOpen}"
          class="dropdown-button">
    <app-franchise-icon [franchiseRoute]="selectedFranchise.route"></app-franchise-icon>
    <span>{{ getFrTitle() | translate }}</span>
    <i class="icon icon-CaretDown"></i>
  </button>

  @if (isDropdownOpen) {
    <div class="dropdown-body">
      @for (itemArr of franchises(); track itemArr; let last = $last) {
        @for (item of itemArr.localizations; track item) {
          <div class="item" (click)="selectFr(item, itemArr)">
            <div class="item-name">
              <app-franchise-icon [franchiseRoute]="item.route"></app-franchise-icon>
              <span>{{ getFrTitle(itemArr, item) | translate }}</span>
            </div>
            @if (isCurrentFr(item)) {
              <span class="icon-Check"></span>
            }
          </div>
        }

        @if (!last) {
          <app-horizontal-divider [margin8]="true"></app-horizontal-divider>
        }

      }
    </div>
  }


</div>
